import { gql, useQuery } from "@apollo/client";

const QUERY = gql`
  query birthdayPhotos {
    birthdayPhotos(first: 1000) {
      id
      image {
        url
      }
    }
  }
`;

const useBirthdayPhoto = () => {
  const { data, loading, error } = useQuery(QUERY);
  return { data, loading, error };
};

export default useBirthdayPhoto;
